<template>
  <section
    class="first-info-card d-flex flex-column gr-2"
    :class="isMobile ? 'px-4 py-12' : 'pt-6 px-6 pb-3 rounded-sm'"
  >
    <a
      v-if="adminkaUrl"
      :href="adminkaUrl"
      class="adminka align-self-start"
      target="_blank"
      rel="noopener noreferrer"
    >{{ t('править', options) }}</a>
    <h2 class="text-h6 bg-gray-0--text">
      {{ title }}
    </h2>
    <div
      class="first-info-card__html d-flex flex-column gr-3 text-body-2 bg-gray-0--text"
      v-html="textHtml/* eslint-disable-line vue/no-v-html */"
    />
  </section>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import type { ContextStore } from 'src/components/pages/info/about-us/index/types'
import { useContextStore } from 'src/store'

const { t, language } = I18NextVue
const options = { ns: language }

defineProps<{
  title: string
  textHtml?: string
  adminkaUrl?: string
}>()

const { context }: ContextStore = useContextStore()
const isMobile = computed(() => context?.flavour === 'mobile')
</script>

<style lang="scss" scoped>
.first-info-card {
  position: relative;
  background: url('/static/_v1/pd/banners/about-us-banner.jpeg') 50% / cover no-repeat;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(54, 54, 54, 0.6);
    border-radius: inherit;
  }

  & > * {
    z-index: 1;
  }
}
</style>
